import { gql } from "@shopify/hydrogen";

export const MEDIA_FRAGMENT = gql`
  fragment Media on Media {
    mediaContentType
    alt
    previewImage {
      url
    }
    ... on MediaImage {
      id
      image {
        url
        width
        height
      }
    }
    ... on Video {
      id
      sources {
        mimeType
        url
      }
    }
    ... on Model3d {
      id
      sources {
        mimeType
        url
      }
    }
    ... on ExternalVideo {
      id
      embedUrl
      host
    }
  }
`;

export const PRODUCT_CARD_FRAGMENT = gql`
  fragment ProductCard on Product {
    id
    title
    publishedAt
    handle
    featuredImage {
      url
      width
      height
      altText
    }
    customField: metafield(namespace: "retailsystem", key: "custom_field") {
      value
    }
    variants(first: 1) {
      nodes {
        id
        image {
          url
          altText
          width
          height
        }
      }
    }
  }
`;

export const ALL_COLLECTIONS_FRAGMENT = gql`
    collections(first: 250, after: $cursor) {
      nodes {
        title
        id
        handle
        image {
          id
          url
          altText
          width
          height
        }
        collectionType: metafield(namespace: "retailsystem", key: "collection_type") {
          value
        }
        categoryLevel: metafield(namespace: "retailsystem", key: "category_level"){
          value
        }
        showInHome: metafield(namespace: "retailsystem", key: "show_in_home"){
          value
        }
        enabled: metafield(namespace: "retailsystem", key: "enabled"){
          value
        }
        collectionPosition: metafield(namespace: "retailsystem", key: "collection_position"){
          value
        }
        subCategories: metafield(namespace: "retailsystem", key: "sub_categories"){
          value
        }
        landscape: metafield(namespace: "retailsystem", key: "landscape"){
          value
        }
        cheaperPrice: metafield(namespace: "retailsystem", key: "cheaper_price"){
          value
        }
        enableInteractiveCategoryList: metafield(namespace: "retailsystem", key: "enable_icl"){
          value
        }
        hasGrandchildren: metafield(namespace: "retailsystem", key: "has_grandchildren"){
          value
        }
        customField: metafield(namespace: "retailsystem", key: "custom_fields"){
          value
        } 
        productRanges: metafield(namespace: "retailsystem", key: "product_ranges"){
            value
        } 
        landscape: metafield(namespace: "retailsystem", key: "landscape"){
          value
        } 
        portrait: metafield(namespace: "retailsystem", key: "portrait"){
          value
        } 
        square: metafield(namespace: "retailsystem", key: "square"){
          value
        } 
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
`;
export const ALL_COLLECTIONS_CUSTOM_FRAGMENT = gql`
    collections(first: 250, after: $cursor, query: "collection_type:custom") {
      edges {
        node {
          title
          id
          handle
          image {
            id
            url
            altText
            width
            height
          }
          collectionType: metafield(namespace: "retailsystem", key: "collection_type") {
            value
          }
          categoryLevel: metafield(namespace: "retailsystem", key: "category_level"){
            value
          }
          showInHome: metafield(namespace: "retailsystem", key: "show_in_home"){
            value
          }
          enabled: metafield(namespace: "retailsystem", key: "enabled"){
            value
          }
          collectionPosition: metafield(namespace: "retailsystem", key: "collection_position"){
            value
          }
          subCategories: metafield(namespace: "retailsystem", key: "sub_categories"){
            value
          }
          landscape: metafield(namespace: "retailsystem", key: "landscape"){
            value
          }
          cheaperPrice: metafield(namespace: "retailsystem", key: "cheaper_price"){
            value
          }
          enableInteractiveCategoryList: metafield(namespace: "retailsystem", key: "enable_icl"){
            value
          }
          hasGrandchildren: metafield(namespace: "retailsystem", key: "has_grandchildren"){
            value
          }
          customField: metafield(namespace: "retailsystem", key: "custom_fields"){
            value
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
`;

export const COLLECTION_BY_HANDLE_FRAGMENT = gql`
    collection(handle: $handle) {
      title
      id
      handle
      descriptionHtml
      image {
        id
        url
        altText
        width
        height
      }
      collectionType: metafield(namespace: "retailsystem", key: "collection_type") {
        value
      }
      categoryLevel: metafield(namespace: "retailsystem", key: "category_level"){
        value
      }
      showInHome: metafield(namespace: "retailsystem", key: "show_in_home"){
        value
      }
      enabled: metafield(namespace: "retailsystem", key: "enabled"){
        value
      }
      collectionPosition: metafield(namespace: "retailsystem", key: "collection_position"){
        value
      }
      subCategories: metafield(namespace: "retailsystem", key: "sub_categories"){
        value
      }
      cheaperPrice: metafield(namespace: "retailsystem", key: "cheaper_price"){
        value
      }
      customField: metafield(namespace: "retailsystem", key: "custom_fields"){
        value
      }
      enableInteractiveCategoryList: metafield(namespace: "retailsystem", key: "enable_icl"){
        value
      }
      hasGrandchildren: metafield(namespace: "retailsystem", key: "has_grandchildren"){
        value
      }
      productRanges: metafield(namespace: "retailsystem", key: "product_ranges"){
        value
      }
      landscape: metafield(namespace: "retailsystem", key: "landscape"){
        value
      }
      square: metafield(namespace: "retailsystem", key: "square"){
        value
      }
      portrait: metafield(namespace: "retailsystem", key: "portrait"){
        value
      }
      subCategoriesJson: metafield(namespace: "retailsystem", key: "sub_categories_json"){
        value
      } 
    }
`;

export const COLLECTION_BY_HANDLE = gql`
    collectionbyhandle(handle: $handle) {
      title
      id
      handle
      descriptionHtml
      image {
        id
        url
        altText
        width
        height
      }
      collectionType: metafield(namespace: "retailsystem", key: "collection_type") {
        value
      }
      subCategories: metafield(namespace: "retailsystem", key: "sub_categories"){
        value
      }
      enableInteractiveCategoryList: metafield(namespace: "retailsystem", key: "enable_icl"){
        value
      }
    }
`;

export const PRODUCT_BY_HANDLE_FRAGMENT = gql`
  product(handle: $handle) {
    compareAtPriceRange {
        maxVariantPrice {
          currencyCode
          amount
        }
        minVariantPrice {
          currencyCode
          amount
        }
      }
      description
      descriptionHtml
      featuredImage {
        url
        width
        height
        altText
      }
      handle
      id
      media(first: 6) {
        edges {
          node {
            ... on MediaImage {
              mediaContentType
              image {
                id
                url
                altText
                width
                height
              }
            }
            ... on Video {
              mediaContentType
              id
              previewImage {
                url
              }
              sources {
                mimeType
                url
              }
            }
            ... on ExternalVideo {
              mediaContentType
              id
              embedUrl
              host
            }
            ... on Model3d {
              mediaContentType
              id
              alt
              mediaContentType
              previewImage {
                url
              }
              sources {
                url
              }
            }
          }
        }
      }
      customizeOptions: metafield(namespace: "retailsystem", key: "customize_options"){
        value
      }
      customField: metafield(namespace: "retailsystem", key: "custom_field"){
        value
      }
      priceRange: metafield(namespace: "retailsystem", key: "price_range"){
        value
      }
      images: metafield(namespace: "retailsystem", key: "images"){
        value
      }
      descriptionBelowButton: metafield(namespace: "retailsystem", key: "description_below_button"){
        value
      }
      minimumQuantity: metafield(namespace: "retailsystem", key: "minimum_quantity"){
        value
      }
      multiplierQuantity: metafield(namespace: "retailsystem", key: "multiplier_quantity"){
        value
      }
      callouts: metafield(namespace: "retailsystem", key: "callouts"){
        value
      }
      bodyHtmlTabs: metafield(namespace: "retailsystem", key: "body_html_tabs"){
        value
      } 
      redirectUrl: metafield(namespace: "retailsystem", key: "redirect"){
        value
      }
      # priceRange {
      #   maxVariantPrice {
      #     currencyCode
      #     amount
      #   }
      #   minVariantPrice {
      #     currencyCode
      #     amount
      #   }
      # }
      seo {
        description
        title
      }
      title
      variants(first: 250) {
        edges {
          node {
            availableForSale
            basePriceOptions: metafield(namespace: "retailsystem", key: "base_price_options"){
              value
            }
            options: metafield(namespace: "retailsystem", key: "options"){
              value
            }
            addOnOptions: metafield(namespace: "retailsystem", key: "add_on_options"){
              value
            }
            oldPrices: metafield(namespace: "retailsystem", key: "old_prices"){
              value
            }
            showInProductPage: metafield(namespace: "retailsystem", key: "show_in_product_page"){
              value
            }
            id
            quantityAvailable
            price {
              amount
              currencyCode
            }
            image {
              id
              url
              altText
              width
              height
              
            }
            selectedOptions {
              name
              value
            }
            sku
            title
            unitPrice {
              amount
              currencyCode
            }
            unitPriceMeasurement {
              measuredType
              quantityUnit
              quantityValue
              referenceUnit
              referenceValue
            }
           
          }
        }
      }
      vendor
      productType
    }
`;
